﻿
(function ($, document, undefined) {

    var Templates = {
        EditForm: '<div data-pa-edit-form></div>',
        PostcodeSearchForm: '<div class="pa__postcodeContainer"></div>',
        PostcodeSearchButton: '<button data-qa-button="postcode-search" class="pa__postcodeSearchButton js-clears-validation js-pa-search-from-edit button {{buttonTheme}}" >Find address</button >',
        SearchForm: '<div data-pa-search-form><label>Postcode lookup<div class="pa__postcodeContainer"><input type="text" data-pa-postcode-search data-qa-input="postcode-search" /><button class="pa__postcodeSearchButton js-pa-search button {{buttonTheme}} " data-qa-button="postcode-search" >Find address</button ></div><a href="#" class="pa__manualLink js-pa-edit">Enter address manually</a></label></div>',
        ResultsForm: '<div data-pa-results-form> <label> Postcode lookup <div class="pa__results"> <span class="pa__selectedPostcode">{{Postcode}}</span><a href="#" class="pa__link js-pa-restart">Change</a> <select data-qa-input="address-results" class="pa__resultsList js-pa-results"> {{#Results}} <option value="{{Id}}">{{Description}}</option> {{/Results}} </select> </div> <a href="#" class="pa__manualLink js-pa-edit">I can\'t find my address in the list</a> </label> </div>',
        ErrorMessage: '<div data-pa-results-form> <label> Postcode lookup <div class="pa__results"> <span class="pa__selectedPostcode">{{Postcode}}</span><a href="#" class="pa__link js-pa-restart">Change</a> <p>An error occurred - please check the postcode is valid and try again.</p><a href="#" class="pa__manualLink js-pa-edit">Enter your address manually</a></label> </div>',
        NoResultsMessage: '<div data-pa-results-form> <label> Postcode lookup <div class="pa__results"> <span class="pa__selectedPostcode">{{Postcode}}</span><a href="#" class="pa__link js-pa-restart">Change</a> <p>No addresses were found - please check the postcode is valid and try again.</p><a href="#" class="pa__manualLink js-pa-edit">Enter your address manually</a></label> </div>'
    };

    function ClearAddress($pod) {
        $('[data-pa-addressline1]', $pod).val('');
        $('[data-pa-addressline2]', $pod).val('');
        $('[data-pa-addressline3]', $pod).val('');
        $('[data-pa-town]', $pod).val('');
        $('[data-pa-postcode]', $pod).val('');
        $('[data-pa-country] option', $pod).removeProp('selected');
    }


    function FillAddress($pod, data) {
        $('[data-pa-addressline1]', $pod).val(data.Address.AddressLine1);
        $('[data-pa-addressline2]', $pod).val(data.Address.AddressLine2);
        $('[data-pa-addressline3]', $pod).val(data.Address.AddressLine3);
        $('[data-pa-town]', $pod).val(data.Address.Town);
        $('[data-pa-postcode]', $pod).val(data.Address.Postcode);
        $('[data-pa-country] option', $pod)
            .removeProp('selected')
            .filter(function () { return $(this).html() == data.Address.Country; })
            .prop('selected', 'selected')
        ;
    }

    function RemoveSearchForms($pod) {
        $('[data-pa-search-form]', $pod).remove();
        $('[data-pa-results-form]', $pod).remove();
    }

    function ToggleView($pod, mode) {
        if ($pod.data('pa-mode') == mode) {
            return;
        }
        RemoveSearchForms($pod);
        switch (mode) {
            case "search":
                $('[data-pa-edit-form]', $pod)
                    .hide()
                    .after(Mustache.render(Templates.SearchForm, {
                        buttonTheme: $pod.data('pa-button-theme')
                    }))
                ;
                break;
            case "edit":
                $('[data-pa-edit-form]', $pod).show();
                break;
        }
        $pod.data('pa-mode', mode);
    }

    function SearchForAddresses($pod, postcode) {
        $pod.data('pa-mode', 'search-results');
        fetch(
            '/api/PostcodeAnywhere/FindByPostcode?postcode=' + postcode, {
                method: 'GET',
                credentials: 'same-origin'
            }
        ).then(function (response) {
            return response.json();
        }).then(function (data) {
            RemoveSearchForms($pod);
            if (data.OnlyOneResult) {
                SelectAddressFromAPI($pod, data.SearchResults[0].Id);
                return;
            }
            if (data.SearchResults.length == 0) {
                $('[data-pa-edit-form]', $pod)
                    .hide()
                    .after(Mustache.render(Templates.NoResultsMessage, {
                        Postcode: data.Postcode
                    }))
                    ;
                return;
            }
            $('[data-pa-edit-form]', $pod)
                .hide()
                .after(Mustache.render(Templates.ResultsForm, {
                    Postcode: data.Postcode,
                    Results: data.SearchResults
                }))
                ;
            $('select.js-pa-results', $pod).focus();

            if ($('select.js-pa-results option[value!=""]', $pod).length == 1) {
                var $selectedOpt = $('select.js-pa-results option[value!=""]', $pod);
                SelectAddressFromAPI($pod, $selectedOpt.val());
                return;
            }
        }).catch(function (data) {
            RemoveSearchForms($pod);
            $('[data-pa-edit-form]', $pod)
                .hide()
                .after(Mustache.render(Templates.ErrorMessage, {
                    Postcode: postcode
                }))
            ;
        });
    }

    function SelectAddressFromAPI($pod, addressId) {
        var data = {
            addressId: addressId
        };
        ClearAddress($pod);
        fetch(
            '/api/PostcodeAnywhere/FetchAddress',
            {
                method: "POST",
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }
        ).then(function (response) {
            return response.json();
        }).then(function (data) {
            FillAddress($pod, data);
            ToggleView($pod, "edit");
        });
    }

    function InitializePostcodeAnywhere() {
        $('[data-postcode-anywhere]').each(function (i, u) {
            var $pod = $(this);

            $pod
                .wrapInner(Templates.EditForm)
            ;

            var $postcode = $('[data-pa-postcode]', $pod);

            $postcode
                .wrap(Templates.PostcodeSearchForm)
                .after(Mustache.render(Templates.PostcodeSearchButton, {
                    buttonTheme: $pod.data('pa-button-theme')
                }));
            ;

            ToggleView($pod, $pod.data('pa-default-mode'));
        });

        $(document).on('click', '.js-pa-edit', function (e) {
            e.preventDefault();
            var $pod = $(this).parents('[data-postcode-anywhere]');
            ClearAddress($pod);
            ToggleView($pod, "edit");
        });

        $(document).on('click', '.js-pa-restart', function (e) {
            e.preventDefault();
            var $pod = $(this).parents('[data-postcode-anywhere]');
            ClearAddress($pod);
            ToggleView($pod, "search");
        });

        $(document).on('click', '.js-pa-search', function (e) {
            e.preventDefault();
            var $pod = $(this).parents('[data-postcode-anywhere]');
            var $txtPostcodeSearch = $('[data-pa-postcode-search]', $pod);
            if ($txtPostcodeSearch.val() == "") {
                ToggleView($pod, "search");
            } else {
                SearchForAddresses($pod, $txtPostcodeSearch.val());
            }
        });

        $(document).on('keydown', '[data-pa-search-form]', function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                var $pod = $(this).parents('[data-postcode-anywhere]');
                $('.js-pa-search', $pod).trigger('click');
            }
        });

        $(document).on('click', '.js-pa-search-from-edit', function (e) {
            e.preventDefault();
            var $pod = $(this).parents('[data-postcode-anywhere]');
            var $txtPostcodeSearch = $('[data-pa-postcode]', $pod);
            if ($txtPostcodeSearch.val() == "") {
                ToggleView($pod, "search");
            } else {
                SearchForAddresses($pod, $txtPostcodeSearch.val());
            }
        });

        $(document).on('change', 'select.js-pa-results', function (e) {
            e.preventDefault();
            var $pod = $(this).parents('[data-postcode-anywhere]');
            var $selectedOpt = $('option:selected', $(this));
            if ($selectedOpt.val() == "" || $selectedOpt.val() == undefined) {
                return;
            }
            SelectAddressFromAPI($pod, $selectedOpt.val());
        });
    }

    $(document).ready(function () {
        InitializePostcodeAnywhere();
    });
})(jQuery, document);